import { negocio } from '../../conexiones';
import IPlantilla from './entidades/IPlantilla';

export default class ModeloPlantilla {
    public DescargarPlantilla(plantilla: IPlantilla) {
        return negocio.post('ProcesarArchivo/DescargarPlantilla', plantilla, { responseType: 'arraybuffer' });
    }
}
